




























































































































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
import { User } from '@/domain/User'
import { Department } from '@/domain/Department'
import { Section } from '@/domain/Section'
import { Role } from '@/domain/Role'
import DepartmentsService from '@/service/DepartmentsService'
import SectionsService from '@/service/SectionsService'
import RolesService from '@/service/RolesService'

@Component
export default class UserDialogComponent extends Vue {
  departmentsService = DepartmentsService.instance
  sectionsService = SectionsService.instance
  rolesService = RolesService.instance

  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  @PropSync("default", { type: User, default: () => new User(), required: true })
  dto!: User

  @Prop({ default: true })
  isNew!: boolean

  /** バリデーション */
  invalid = false

  departments: Department[] = []
  sections: Section[] = []
  roles: Role[] = []

  mounted() {
    /* 部門 */
    this.departmentsService.findAll()
      .then(x => this.departments = x)
    /* 部署 */
    this.sectionsService.findAll()
      .then(x => this.sections = x)
    /* 権限 */
    this.rolesService.findAll()
      .then(x => this.roles = x)
  }

  /**
   * 初期化
   */
  reset() {
    this.dto = new User()
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.dto)
    this.reset()
  }

}
